/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("polyfills/fetch");
var classListPolyfill = require("polyfills/classList");

import baustein from "baustein";
import environment from "../modules/environment";
import analytics from "../analytics/analytics";
import doubleclickEvents from "../analytics/doubleclick-events";

export default baustein.register("lyst-checkout", {
    init: function() {
        if (environment.get("doubleclickEvent")) {
            this._trackDoubleclickEvent();
        }
    },

    _trackDoubleclickEvent: function() {
        var event = environment.get("doubleclickEvent");
        analytics.tagEvent(
            analytics.TAG_NETWORKS.DOUBLECLICK,
            doubleclickEvents[event.name],
            event.data
        );
    }
});

